<template>
  <div id="child-info">
    <page-heading>
      Which grade and school will <span class="heading__span--child-name" >{{ currentChild.firstName }}</span> be attending?
    </page-heading>
    <div id="content">
      <div class="row">
        <div class="col-xs-12">
          <child-info-form/>
        </div>
      </div>
    </div>
    <page-controls :path="page"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import childInfoForm from '@/components/child-info-form.vue';

export default {
  name: 'ChildInfo',
  components: {
    childInfoForm,
  },
  data() {
    return {
      childId: this.$route.params.childId,
      page: '',
    };
  },
  mounted() {
    this.getNextPage(this.childId);
  },
  computed: {
    ...mapGetters([
      'currentChild',
      'children',
    ]),
  },
  methods: {
    getNextPage(pageId) {
      if (this.children.length - 1 === parseInt(pageId, 10)) {
        this.page = '/attendance';
      } else {
        this.page = `/child-info/${parseInt(pageId, 10) + 1}`;
      }
    },
  },
  watch: {
    '$route.params.childId': function (to) {
      this.getNextPage(to);
    },
  },
};
</script>

<style lang="sass">

</style>

